import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout wrapper for legacy /home route (now redirector)
export const Route = createFileRoute('/_authenticated/_dashboard/home')({
  component: () => <Outlet />,
})
